<app-warning-modal />

<!-- VERSÃO MOBILE -->
<div class="lg:hidden min-h-screen-safe relative flex flex-col">
  <!-- Imagem de fundo fullscreen -->
  <div class="absolute inset-0 bg-cover bg-center bg-no-repeat"
    style="background-image: url('assets/img/LandingPage-1.png');"></div>

  <!-- Overlay escuro -->
  <div class="absolute inset-0 bg-black/40"></div>

  <!-- Conteúdo Mobile -->
  <div class="relative z-10 flex-1 flex flex-col justify-center items-center px-6 py-12 safe-area-inset overflow-y-auto">

    <!-- Card branco -->
    <div class="w-full max-w-sm bg-white rounded-2xl p-8 shadow-2xl">

      <!-- Logo -->
      <div class="mb-6 cursor-pointer" (click)="navigateToLanding()">
        <img src="assets/icons/logo-v2.svg" class="h-6 max-w-[200px]" />
      </div>

      <!-- Título -->
      <div class="mb-2">
        <h1 class="text-2xl font-semibold text-neutral-900">
          Redefinir senha
        </h1>
      </div>

      <!-- Descrição -->
      <p class="text-sm text-neutral-600 mb-6">
        Digite o código enviado para <span class="font-medium">{{ email }}</span> e crie sua nova senha.
      </p>

      <!-- Inputs de código -->
      <div class="mb-5">
        <label class="block text-sm font-medium text-neutral-900 mb-2">Código de verificação</label>
        <!-- Input invisível que captura toda a digitação -->
        <input 
          id="hiddenCodeInputMobile"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          autocomplete="one-time-code"
          [value]="hiddenCodeValue"
          (input)="onHiddenInput($event)"
          (keydown)="onHiddenKeyDown($event)"
          (blur)="onHiddenBlur()"
          style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;"
          maxlength="6">
        <!-- Boxes visuais -->
        <div class="flex justify-between gap-2 cursor-text" (click)="focusHiddenInput('mobile')">
          <div *ngFor="let digit of codeDigits; let i = index"
            class="w-10 h-12 flex items-center justify-center text-xl font-semibold rounded-lg border bg-white transition-all duration-200 select-none"
            [ngClass]="activeCodeIndex === i && isFocused ? 'border-westetics-purple-600 ring-2 ring-westetics-purple-600' : (digit ? 'border-neutral-400' : 'border-neutral-200')">
            <span *ngIf="digit">{{ digit }}</span>
            <span *ngIf="!digit && activeCodeIndex === i && isFocused" class="w-0.5 h-6 bg-westetics-purple-600 animate-pulse"></span>
          </div>
        </div>
      </div>

      <!-- Formulário de senha -->
      <form [formGroup]="passwordForm" class="space-y-4">
        <!-- Campo Nova Senha -->
        <div>
          <label for="password-mobile" class="block text-sm font-medium text-neutral-900 mb-2">
            Nova senha
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <input formControlName="password" id="password-mobile" name="password"
              [type]="showPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="••••••••"
              class="block w-full pl-10 pr-12 py-3 rounded-lg border border-neutral-200 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200 bg-white">
            <button type="button" (click)="togglePasswordVisibility()" [attr.aria-pressed]="showPassword"
              class="absolute inset-y-0 right-0 pr-3 flex items-center text-neutral-400 hover:text-neutral-600 transition-colors">
              <svg *ngIf="!showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg *ngIf="showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
        </div>

        <!-- Validações da senha -->
        <div class="space-y-2 text-sm">
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasMinLength ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasMinLength" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasMinLength ? 'text-westetics-purple-600' : 'text-neutral-500'">Mínimo 8 caracteres</span>
          </div>
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasLowercase ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasLowercase" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasLowercase ? 'text-westetics-purple-600' : 'text-neutral-500'">Caracteres minúsculos (a-z)</span>
          </div>
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasUppercase ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasUppercase" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasUppercase ? 'text-westetics-purple-600' : 'text-neutral-500'">Caracteres maiúsculos (A-Z)</span>
          </div>
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasNumber ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasNumber" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasNumber ? 'text-westetics-purple-600' : 'text-neutral-500'">Números (0-9)</span>
          </div>
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasSpecialChar ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasSpecialChar" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasSpecialChar ? 'text-westetics-purple-600' : 'text-neutral-500'">Caracteres especiais (!&#64;#$%)</span>
          </div>
        </div>

        <!-- Campo Confirmar Senha -->
        <div>
          <label for="confirm-password-mobile" class="block text-sm font-medium text-neutral-900 mb-2">
            Confirmar senha
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <input formControlName="confirmPassword" id="confirm-password-mobile" name="confirmPassword"
              [type]="showConfirmPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="••••••••"
              class="block w-full pl-10 pr-12 py-3 rounded-lg border text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200 bg-white"
              [ngClass]="passwordForm.get('confirmPassword')?.value && !passwordsMatch() ? 'border-red-400' : 'border-neutral-200'">
            <button type="button" (click)="toggleConfirmPasswordVisibility()" [attr.aria-pressed]="showConfirmPassword"
              class="absolute inset-y-0 right-0 pr-3 flex items-center text-neutral-400 hover:text-neutral-600 transition-colors">
              <svg *ngIf="!showConfirmPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg *ngIf="showConfirmPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
          <p *ngIf="passwordForm.get('confirmPassword')?.value && !passwordsMatch()" class="text-red-500 text-xs mt-1">As senhas não coincidem</p>
        </div>

        <!-- Botão de Submit -->
        <button type="button" 
          (click)="onSubmit()"
          [disabled]="!canSubmit() || loading" 
          class="w-full py-3.5 px-4 rounded-full font-medium text-white transition-all duration-200 flex items-center justify-center gap-2
                 bg-neutral-900 hover:bg-neutral-800 
                 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:ring-offset-2
                 disabled:bg-neutral-300 disabled:cursor-not-allowed">
          <app-loading-spinner *ngIf="loading" size="sm"></app-loading-spinner>
          {{ loading ? 'Alterando...' : 'Alterar senha' }}
        </button>
      </form>

      <!-- Reenviar código -->
      <div class="mt-5 text-center">
        <p class="text-sm text-neutral-600 mb-2">Não recebeu o código?</p>
        <button type="button" 
          (click)="resendCode()" 
          [disabled]="resendLoading"
          class="text-sm text-neutral-900 font-medium hover:underline transition-colors disabled:text-neutral-400">
          <app-loading-spinner *ngIf="resendLoading" size="xs" class="inline-block mr-1"></app-loading-spinner>
          {{ resendLoading ? 'Reenviando...' : 'Reenviar código' }}
        </button>
      </div>

      <!-- Link para voltar -->
      <div class="mt-4 text-center">
        <a (click)="navigateToForgotPassword()" class="text-sm text-neutral-600 hover:text-neutral-900 underline transition-colors cursor-pointer">
          Voltar
        </a>
      </div>
    </div>
  </div>
</div>

<!-- VERSÃO DESKTOP - Layout Split -->
<div class="hidden lg:flex min-h-screen flex-row">
  <!-- Lado Esquerdo - Formulário -->
  <div class="flex-1 flex flex-col justify-center items-center bg-[#efeee9] overflow-y-auto py-8">
    <div class="w-full max-w-md flex-col gap-4 flex">
      <!-- Logo -->
      <div class="cursor-pointer" (click)="navigateToLanding()">
        <img src="assets/icons/logo-v2.svg" class="h-6 max-w-[200px]" />
      </div>
      <!-- Título -->
      <h1 class="text-3xl font-bold text-neutral-900">
        Redefinir senha
      </h1>

      <!-- Descrição -->
      <p class="text-sm text-neutral-600">
        Digite o código enviado para <span class="font-medium">{{ email }}</span> e crie sua nova senha.
      </p>

      <!-- Inputs de código -->
      <div>
        <label class="block text-sm font-medium text-neutral-900 mb-2">Código de verificação</label>
        <!-- Input invisível que captura toda a digitação -->
        <input 
          id="hiddenCodeInputDesktop"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          autocomplete="one-time-code"
          [value]="hiddenCodeValue"
          (input)="onHiddenInput($event)"
          (keydown)="onHiddenKeyDown($event)"
          (blur)="onHiddenBlur()"
          style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;"
          maxlength="6">
        <!-- Boxes visuais -->
        <div class="flex justify-start gap-3 cursor-text" (click)="focusHiddenInput('desktop')">
          <div *ngFor="let digit of codeDigits; let i = index"
            class="w-12 h-14 flex items-center justify-center text-2xl font-semibold rounded-lg border bg-white transition-all duration-200 select-none"
            [ngClass]="activeCodeIndex === i && isFocused ? 'border-neutral-900 ring-2 ring-neutral-900' : (digit ? 'border-neutral-400' : 'border-neutral-200')">
            <span *ngIf="digit">{{ digit }}</span>
            <span *ngIf="!digit && activeCodeIndex === i && isFocused" class="w-0.5 h-6 bg-neutral-900 animate-pulse"></span>
          </div>
        </div>
      </div>

      <!-- Formulário de senha -->
      <form [formGroup]="passwordForm" class="space-y-5">
        <!-- Campo Nova Senha -->
        <div>
          <label for="password" class="block text-sm font-medium text-neutral-900 mb-2">
            Nova senha
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <input formControlName="password" id="password" name="password"
              [type]="showPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="••••••••"
              class="block w-full pl-10 pr-12 py-3 rounded-lg border border-neutral-200 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200">
            <button type="button" (click)="togglePasswordVisibility()" [attr.aria-pressed]="showPassword"
              class="absolute inset-y-0 right-0 pr-3 flex items-center text-neutral-400 hover:text-neutral-600 transition-colors">
              <svg *ngIf="!showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg *ngIf="showPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
        </div>

        <!-- Validações da senha -->
        <div class="grid grid-cols-2 gap-2 text-sm">
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasMinLength ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasMinLength" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasMinLength ? 'text-westetics-purple-600' : 'text-neutral-500'">Mínimo 8 caracteres</span>
          </div>
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasLowercase ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasLowercase" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasLowercase ? 'text-westetics-purple-600' : 'text-neutral-500'">Minúsculos (a-z)</span>
          </div>
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasUppercase ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasUppercase" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasUppercase ? 'text-westetics-purple-600' : 'text-neutral-500'">Maiúsculos (A-Z)</span>
          </div>
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasNumber ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasNumber" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasNumber ? 'text-westetics-purple-600' : 'text-neutral-500'">Números (0-9)</span>
          </div>
          <div class="flex items-center gap-2 col-span-2">
            <div class="w-4 h-4 rounded border flex items-center justify-center transition-colors"
              [ngClass]="passwordValidations.hasSpecialChar ? 'bg-westetics-purple-600 border-westetics-purple-600' : 'border-neutral-300'">
              <svg *ngIf="passwordValidations.hasSpecialChar" class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span [ngClass]="passwordValidations.hasSpecialChar ? 'text-westetics-purple-600' : 'text-neutral-500'">Caracteres especiais (!&#64;#$%)</span>
          </div>
        </div>

        <!-- Campo Confirmar Senha -->
        <div>
          <label for="confirm-password" class="block text-sm font-medium text-neutral-900 mb-2">
            Confirmar senha
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-neutral-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <input formControlName="confirmPassword" id="confirm-password" name="confirmPassword"
              [type]="showConfirmPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="••••••••"
              class="block w-full pl-10 pr-12 py-3 rounded-lg border text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all duration-200"
              [ngClass]="passwordForm.get('confirmPassword')?.value && !passwordsMatch() ? 'border-red-400' : 'border-neutral-200'">
            <button type="button" (click)="toggleConfirmPasswordVisibility()" [attr.aria-pressed]="showConfirmPassword"
              class="absolute inset-y-0 right-0 pr-3 flex items-center text-neutral-400 hover:text-neutral-600 transition-colors">
              <svg *ngIf="!showConfirmPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg *ngIf="showConfirmPassword" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
          <p *ngIf="passwordForm.get('confirmPassword')?.value && !passwordsMatch()" class="text-red-500 text-xs mt-1">As senhas não coincidem</p>
        </div>

        <!-- Botão de Submit -->
        <button type="button" 
          (click)="onSubmit()"
          [disabled]="!canSubmit() || loading" 
          class="w-full py-3.5 px-4 rounded-full font-medium text-white transition-all duration-200 flex items-center justify-center gap-2
                 bg-neutral-900 hover:bg-neutral-800 
                 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:ring-offset-2
                 disabled:bg-neutral-300 disabled:cursor-not-allowed">
          <app-loading-spinner *ngIf="loading" size="sm"></app-loading-spinner>
          {{ loading ? 'Alterando...' : 'Alterar senha' }}
        </button>
      </form>

      <!-- Reenviar código -->
      <div class="mt-2 flex items-center gap-2">
        <span class="text-sm text-neutral-600">Não recebeu o código?</span>
        <button type="button" 
          (click)="resendCode()" 
          [disabled]="resendLoading"
          class="text-sm text-neutral-900 font-medium hover:underline transition-colors disabled:text-neutral-400">
          <app-loading-spinner *ngIf="resendLoading" size="xs" class="inline-block mr-1"></app-loading-spinner>
          {{ resendLoading ? 'Reenviando...' : 'Reenviar código' }}
        </button>
      </div>

      <!-- Link para voltar -->
      <div>
        <a (click)="navigateToForgotPassword()" class="text-sm text-neutral-600 hover:text-neutral-900 underline transition-colors cursor-pointer">
          Voltar
        </a>
      </div>
    </div>
  </div>

  <!-- Lado Direito - Imagem -->
  <div class="flex-1 relative overflow-hidden">
    <!-- Imagem de fundo -->
    <div class="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style="background-image: url('assets/img/LandingPage-1.png');"></div>

    <!-- Overlay escuro sutil -->
    <div class="absolute inset-0 bg-black/20"></div>

    <!-- Conteúdo sobre a imagem -->
    <div class="relative z-10 flex flex-col justify-end items-start p-12 xl:p-16 pb-20 w-full h-full">
      <!-- Texto de boas-vindas -->
      <h2 class="text-5xl xl:text-6xl font-bold text-white mb-4">
        Nova senha
      </h2>
      <p class="text-white/90 text-base max-w-md leading-relaxed">
        Crie uma senha forte e segura para proteger sua conta.
      </p>
    </div>
  </div>
</div>
